import axios from 'axios'
import { loadAbort } from 'utilities'

export const registerUser = (data: {
  email: string
  first_name: string
  last_name: string
  password: string
  subgroup: string
  validation_code: string
  referral_code: string
}) => {
  const controller = loadAbort()
  const url = `${process.env.REACT_APP_BASE_URL}/api/auth/register/`

  // Crear FormData para application/x-www-form-urlencoded
  const formData = new URLSearchParams()
  formData.append('email', data.email)
  formData.append('first_name', data.first_name)
  formData.append('last_name', data.last_name)
  formData.append('password', data.password)
  formData.append('subgroup', data.subgroup)
  formData.append('validation_code', data.validation_code)
  formData.append('referral_code', data.referral_code)

  return {
    call: axios.post(url, formData, {
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json; version=0.0.0',
      },
    }),
    controller,
  }
}

export const sendEmailValidation = (email: string, companyUuid: string) => {
  const controller = loadAbort()
  const url = `${process.env.REACT_APP_BASE_URL}/dashboard/api/email/email_validation/`

  return {
    call: axios.post(
      url,
      {
        email,
        company: companyUuid,
      },
      {
        signal: controller.signal,
        headers: {
          'Content-Type': 'application/json',
        },
      },
    ),
    controller,
  }
}

export const checkEmailValidation = (email: string) => {
  const controller = loadAbort()
  const url = `${
    process.env.REACT_APP_BASE_URL
  }/dashboard/api/email/check_validation/?email=${encodeURIComponent(email)}`

  return {
    call: axios.get(url, {
      signal: controller.signal,
      headers: {
        Accept: 'application/json; version=0.0.0',
      },
    }),
    controller,
  }
}

export const resetPassword = (
  password: string,
  userUUID: string,
  token: string,
) => {
  const controller = loadAbort()
  const url = `${process.env.REACT_APP_BASE_URL}/api/auth/password/reset/confirm/`
  return {
    call: axios.post(
      url,
      {
        new_password1: password,
        new_password2: password,
        uid: userUUID,
        token,
      },
      { signal: controller.signal },
    ),
    controller,
  }
}
